<template>
    <div>
        <LabelTemplateToPrintDialog
            :is-open="labelToPrintTypeDialog"
            :template-type-ids="templateTypeIds"
            :selected-list-item-data="selectedListItem"
            :customer-id="customerId"
            @on-submit="saveLabelToPrintType"
            @on-close="closeLabelToPrintTypeDialog"
        />
        <v-dialog
            :value="isOpen"
            scrollable
            max-width="1000px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title class="d-flex align-center justify-space-between">
                    <h1 class="text-subtitle-1">
                        Drukowanie etykiet
                    </h1>
                    <v-checkbox
                        v-model="printAllLabelsChecked"
                        :ripple="false"
                        label="Drukuj wszystkie"
                        class="mb-0"
                        hide-details
                        @change="selectAllTemplatesToPrint($event)"
                    />
                </v-card-title>
                <v-card-text>
                    <v-row v-if="campaignPrint" no-gutters align="center" class="mb-1">
                        <v-col cols="12" sm="4">
                            <v-checkbox
                                v-model="printLogisticsLabelsChecked"
                                :ripple="false"
                                label="Drukuj etykiety logistyczne"
                                class="mb-1"
                                hide-details
                                @change="onLogisticsLabelsChange($event)"
                            />
                        </v-col>
                        <v-col v-if="campaignPrint" cols="12" sm="4">
                            <v-checkbox
                                v-model="printPalletTagsChecked"
                                :ripple="false"
                                label="Drukuj zawieszki paletowe"
                                class="mb-1"
                                hide-details
                                @change="onPalletTagsChange($event)"
                            />
                        </v-col>
                        <v-col v-if="campaignPrint" cols="12" sm="4">
                            <v-checkbox
                                v-model="printSetLabelsChecked"
                                :ripple="false"
                                label="Drukuj etykiety zestawów"
                                class="mb-1"
                                hide-details
                                @change="onSetLabelsChange($event)"
                            />
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-expansion-panels v-model="expandedPanels" accordion multiple>
                        <v-expansion-panel
                            v-for="(shippingLabelPositionPackage, shippingLabelPositionPackageIndex) in templatesToPrint"
                            :key="shippingLabelPositionPackageIndex"
                        >
                            <v-expansion-panel-header>
                                <div class="w-100 d-flex flex-column">
                                    <div
                                        v-if="shippingLabelPositionPackage.addressData"
                                        class="text-subtitle-1 font-weight-medium"
                                    >
                                        <strong>{{ shippingLabelPositionPackage.addressData }}</strong>
                                    </div>
                                    <v-divider
                                        v-if="shippingLabelPositionPackage.addressData"
                                        width="65%"
                                        class="flex-start mb-3 mt-1"
                                    />
                                    <v-row no-gutters align="center" dense>
                                        <v-col cols="12" sm="1">
                                            <v-simple-checkbox
                                                v-model="shippingLabelPositionPackage.isSelected"
                                                :ripple="false"
                                                @input="selectShippingLabelPackage(shippingLabelPositionPackage, $event)"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            Nazwa: <strong>{{ shippingLabelPositionPackage.name }}</strong>
                                        </v-col>
                                        <v-col cols="12" sm="5">
                                            Szablon: <strong>{{ shippingLabelPositionPackage.templateName }}</strong>
                                        </v-col>
                                        <v-col v-if="campaignPrint" cols="12" sm="2" class="d-flex align-center">
                                            <span @click.stop @mousedown.stop>
                                                <v-simple-checkbox
                                                    v-model="shippingLabelPositionPackage.logisticsLabelSelected"
                                                    :ripple="false"
                                                    @input="selectLogisticsLabel(shippingLabelPositionPackage, $event)"
                                                />
                                            </span>
                                            <span class="ml-2">Etykieta logistyczna</span>
                                        </v-col>
                                        <v-col v-if="!campaignPrint" cols="12" sm="2">
                                            <v-container fluid class="pa-0">
                                                <v-row justify="end" dense>
                                                    <v-tooltip :open-delay="tooltipDelay" top>
                                                        <template #activator="{on}">
                                                            <v-btn
                                                                icon
                                                                data-sentry-label="Edycja etykiety"
                                                                v-on="on"
                                                                @click="showLabelToPrintTypeDialog(shippingLabelPositionPackage, $event)"
                                                            >
                                                                <v-icon color="blue">
                                                                    mdi-pencil
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Edycja</span>
                                                    </v-tooltip>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-expansion-panel-header>

                            <v-divider />

                            <!--  TOWARY -->
                            <v-expansion-panel-content
                                v-if="shippingLabelPositionPackage.shippingOrderPositionPackageGoods.length > 0"
                            >
                                <v-row justify="end" dense>
                                    <v-col cols="12" sm="10">
                                        <v-row align="center">
                                            <v-col>
                                                <strong>Towary</strong>
                                                <v-row
                                                    v-for="(good, goodIndex) in shippingLabelPositionPackage.shippingOrderPositionPackageGoods"
                                                    :key="goodIndex"
                                                    no-gutters
                                                    align="center"
                                                    dense
                                                >
                                                    <v-col cols="12" sm="1">
                                                        <v-simple-checkbox
                                                            v-model="good.isSelected"
                                                            :disabled="isGoodDisabledFromPrint(good)"
                                                            :ripple="false"
                                                            @input="updateTemplatesToPrint(good, $event)"
                                                        />
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="5"
                                                        :class="{'text--disabled': isGoodDisabledFromPrint(good)}"
                                                    >
                                                        Nazwa: <strong>{{ good.name }}</strong>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        sm="5"
                                                        :class="{'text--disabled': isGoodDisabledFromPrint(good)}"
                                                    >
                                                        Szablon: <strong>{{ good.templateName }}</strong>
                                                    </v-col>
                                                    <v-col v-if="!campaignPrint" cols="12" sm="1">
                                                        <v-container fluid class="pa-0">
                                                            <v-row justify="end" dense>
                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                    <template #activator="{on}">
                                                                        <v-btn
                                                                            icon
                                                                            data-sentry-label="Edycja etykiety"
                                                                            :disabled="isGoodDisabledFromPrint(good)"
                                                                            v-on="on"
                                                                            @click="showLabelToPrintTypeDialog(good, $event)"
                                                                        >
                                                                            <v-icon color="blue">
                                                                                mdi-pencil
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Edycja</span>
                                                                </v-tooltip>
                                                            </v-row>
                                                        </v-container>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                            <!-- /TOWARY -->
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
                <v-divider />

                <v-card-actions>
                    <v-btn color="error" text data-sentry-label="Anuluj" @click="onClose">
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        data-sentry-label="Drukuj"
                        :loading="actionLoading"
                        :disabled="printShippingLabels.printShippingLabels.length == 0 && selectedLogisticsLabels.length == 0"
                        @click="printTemplateLabels()"
                    >
                        Drukuj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LabelTemplateToPrintDialog from './LabelTemplateToPrintDialog.vue'
import tooltipDelay from '@/mixins/tooltip'
import { openPdfFile } from '@/utils/pdfHandler'
import { errorHandler } from '@/utils/errorHandler'
import { orderBy } from 'lodash'

export default {
    name: 'PrintLabelTemplatesDialog',
    components: {
        LabelTemplateToPrintDialog
    },
    mixins: [
        tooltipDelay,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        templatesToPrintData: {
            type: Array,
            default: () => []
        },
        customerId: {
            type: Number,
            default: null
        },
        campaignPrint: {
            type: Boolean
        },
    },
    data() {
        return {
            expandedPanels: [],
            templatesToPrint: [],
            templateTypeIds: null,
            labelToPrintTypeDialog: false,
            selectedListItem: {},
            printAllLabelsChecked: false,
            printLogisticsLabelsChecked: false,
            printPalletTagsChecked: false,
            printSetLabelsChecked: false,
            printShippingLabels: {
                printShippingLabels: []
            },
            selectedLogisticsLabels: [],
            actionLoading: false
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                const templates = JSON.parse(JSON.stringify(this.templatesToPrintData))

                templates.forEach((packageItem, packageIndex) => {
                    packageItem['packageIndex'] = packageIndex
                    packageItem['goodIndex'] = -1
                    packageItem.isSelected = false
                    packageItem.logisticsLabelSelected = false

                    if (Array.isArray(packageItem.shippingOrderPositionPackageGoods)) {
                        packageItem.shippingOrderPositionPackageGoods.forEach((goodItem, goodIndex) => {
                            goodItem['goodIndex'] = goodIndex
                            goodItem['packageIndex'] = packageIndex
                            goodItem.isSelected = false
                        })
                    }
                })

                this.templatesToPrint = templates

                this.templatesToPrint.forEach((_, index) => {
                    this.expandedPanels.push(index)
                })
            } else {
                setTimeout(() => {
                    this.templatesToPrint = []
                    this.expandedPanels = []
                    this.templateTypeIds = null
                    this.labelToPrintTypeDialog = false
                    this.selectedListItem = {}
                    this.printShippingLabels.printShippingLabels = []
                    this.printAllLabelsChecked = false
                    this.printPalletTagsChecked = false
                    this.printSetLabelsChecked = false
                    this.selectedLogisticsLabels = []
                    this.printLogisticsLabelsChecked = false
                }, 500)
            }
        }
    },
    methods: {
        isGoodDisabledFromPrint(good) {
            return good?.unitPackageType?.id === 49 // pakowanie luzem
        },
        onPalletTagsChange(value) {
            if (value) {
                this.printLogisticsLabelsChecked = false
                this.printSetLabelsChecked = false
                this.printAllLabelsChecked = false

                this.printShippingLabels.printShippingLabels = []
                this.selectedLogisticsLabels = []
                this.templatesToPrint.forEach(packageItem => {
                    packageItem.isSelected = true
                    packageItem.logisticsLabelSelected = false

                    if (Array.isArray(packageItem.shippingOrderPositionPackageGoods)) {
                        packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                            good.isSelected = false
                        })
                    }

                    const existsIndex = this.printShippingLabels.printShippingLabels.findIndex(item =>
                        item.shippingLabelPositionPackageId === packageItem.shippingLabelPositionPackageId
                    )

                    if (existsIndex === -1) {
                        this.printShippingLabels.printShippingLabels.push({
                            ...packageItem,
                            shippingOrderPositionPackageGoods: []
                        })
                    }
                })
            } else {
                // Unchecking
                this.templatesToPrint.forEach(packageItem => {
                    packageItem.isSelected = false
                    if (Array.isArray(packageItem.shippingOrderPositionPackageGoods)) {
                        packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                            good.isSelected = false
                        })
                    }
                })
                this.printShippingLabels.printShippingLabels = []
            }
        },
        onSetLabelsChange(value) {
            if (value) {
                this.printLogisticsLabelsChecked = false
                this.printPalletTagsChecked = false
                this.printAllLabelsChecked = false
                this.printShippingLabels.printShippingLabels = []
                this.selectedLogisticsLabels = []
                this.templatesToPrint.forEach(packageItem => {
                    packageItem.isSelected = false
                    packageItem.logisticsLabelSelected = false

                    if (Array.isArray(packageItem.shippingOrderPositionPackageGoods)) {
                        packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                            const selectable = !this.isGoodDisabledFromPrint(good)

                            good.isSelected = selectable

                            if (selectable) {
                                const existsIndex = this.printShippingLabels.printShippingLabels.findIndex(item =>
                                    item.shippingLabelPositionPackageGoodId === good.shippingLabelPositionPackageGoodId
                                )

                                if (existsIndex === -1) {
                                    this.printShippingLabels.printShippingLabels.push(good)
                                }
                            }
                        })
                    }
                })
            } else {
                // Unchecking
                this.templatesToPrint.forEach(packageItem => {
                    if (Array.isArray(packageItem.shippingOrderPositionPackageGoods)) {
                        packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                            good.isSelected = false
                        })
                    }
                })
                this.printShippingLabels.printShippingLabels = this.printShippingLabels.printShippingLabels.filter(
                    item => !item.shippingLabelPositionPackageGoodId
                )
            }
        },
        showLabelToPrintTypeDialog(selectedListItem, $event) {
            $event.stopPropagation()
            this.selectedListItem = selectedListItem
            this.labelToPrintTypeDialog = true
            this.templateTypeIds = selectedListItem.shippingLabelTemplateTypeId
        },
        saveLabelToPrintType(template) {
            this.selectedListItem.shippingLabelTemplateId = template.id
            this.selectedListItem.templateName = template.name
            this.selectedListItem.shippingLabelTemplateTypeId = [template.type]
            const index = this.templatesToPrint.findIndex(item => item.index === this.selectedListItem)

            this.templatesToPrint[index] = this.selectedListItem
            this.labelToPrintTypeDialog = false
        },
        closeLabelToPrintTypeDialog() {
            this.labelToPrintTypeDialog = false
        },
        onLogisticsLabelsChange(value) {
            if (value) {
                this.printPalletTagsChecked = false
                this.printSetLabelsChecked = false
                this.printAllLabelsChecked = false
                this.printShippingLabels.printShippingLabels = []
                this.selectedLogisticsLabels = []
                this.templatesToPrint.forEach(packageItem => {
                    packageItem.isSelected = false
                    packageItem.logisticsLabelSelected = true
                    if (Array.isArray(packageItem.shippingOrderPositionPackageGoods)) {
                        packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                            good.isSelected = false
                        })
                    }
                    this.selectedLogisticsLabels.push({
                        shippingLabelPositionPackageId: packageItem.shippingLabelPositionPackageId
                    })
                })
            } else {
                this.templatesToPrint.forEach(packageItem => {
                    packageItem.logisticsLabelSelected = false
                })
                this.selectedLogisticsLabels = []
            }
        },
        selectLogisticsLabel(packageItem, isChecked) {
            packageItem.logisticsLabelSelected = isChecked
            if (isChecked) {
                if (!this.selectedLogisticsLabels.find(item => item.shippingLabelPositionPackageId === packageItem.shippingLabelPositionPackageId)) {
                    this.selectedLogisticsLabels.push({
                        shippingLabelPositionPackageId: packageItem.shippingLabelPositionPackageId
                    })
                }
                this.printAllLabelsChecked = false
            } else {
                const index = this.selectedLogisticsLabels.findIndex(item =>
                    item.shippingLabelPositionPackageId === packageItem.shippingLabelPositionPackageId
                )

                if (index > -1) {
                    this.selectedLogisticsLabels.splice(index, 1)
                }
                this.printAllLabelsChecked = false
                if (this.printLogisticsLabelsChecked) {
                    this.printLogisticsLabelsChecked = false
                }
            }
        },
        selectAllTemplatesToPrint(value) {
            if (value) {
                this.printLogisticsLabelsChecked = false
                this.printPalletTagsChecked = false
                this.printSetLabelsChecked = false
                this.printShippingLabels.printShippingLabels = []
                this.selectedLogisticsLabels = []

                this.templatesToPrint.forEach(packageItem => {
                    packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                        if (!this.isGoodDisabledFromPrint(good)) {
                            good.isSelected = true
                            this.printShippingLabels.printShippingLabels.push(good)
                        }
                    })
                    packageItem.isSelected = true
                    this.printShippingLabels.printShippingLabels.push(packageItem)
                    if (this.campaignPrint) {
                        packageItem.logisticsLabelSelected = true
                        this.selectedLogisticsLabels.push({
                            shippingLabelPositionPackageId: packageItem.shippingLabelPositionPackageId
                        })
                    }
                })
            } else {
                this.templatesToPrint.forEach(packageItem => {
                    packageItem.shippingOrderPositionPackageGoods.forEach(good => {
                        good.isSelected = false
                    })
                    packageItem.isSelected = false
                    packageItem.logisticsLabelSelected = false
                })
                this.printShippingLabels.printShippingLabels = []
                this.selectedLogisticsLabels = []
                this.printAllLabelsChecked = false
            }
        },
        selectShippingLabelPackage(packageItem, isChecked) {
            if (isChecked) {
                const packageGoodsToSelect = this.getAvailableGoodsToPrint(packageItem)

                const existsIndex = this.printShippingLabels.printShippingLabels.findIndex(item =>
                    item?.shippingLabelPositionPackageId === packageItem.shippingLabelPositionPackageId
                )

                if (existsIndex === -1) {
                    this.printShippingLabels.printShippingLabels.push({
                        ...packageItem,
                        shippingOrderPositionPackageGoods: packageGoodsToSelect
                    })
                }
            } else {
                const index = this.printShippingLabels.printShippingLabels.findIndex(item =>
                    item?.shippingLabelPositionPackageId === packageItem.shippingLabelPositionPackageId
                )

                if (index > -1) {
                    this.printShippingLabels.printShippingLabels.splice(index, 1)
                }

                if (this.printPalletTagsChecked) {
                    this.printPalletTagsChecked = false
                }
            }
        },
        updateTemplatesToPrint(good, value) {
            if (value) {
                const existsIndex = this.printShippingLabels.printShippingLabels.findIndex(item =>
                    item?.shippingLabelPositionPackageGoodId === good.shippingLabelPositionPackageGoodId
                )

                if (existsIndex === -1) {
                    this.printShippingLabels.printShippingLabels.push(good)
                }
            } else {
                const index = this.printShippingLabels.printShippingLabels.findIndex(item =>
                    item?.shippingLabelPositionPackageGoodId === good.shippingLabelPositionPackageGoodId
                )

                if (index > -1) {
                    this.printShippingLabels.printShippingLabels.splice(index, 1)
                }

                if (this.printSetLabelsChecked) {
                    this.printSetLabelsChecked = false
                }
            }
        },
        getAvailableGoodsToPrint(packageItem) {
            const goods = Array.isArray(packageItem?.shippingOrderPositionPackageGoods)
                ? packageItem.shippingOrderPositionPackageGoods
                : []

            return goods.filter(good => good && !this.isGoodDisabledFromPrint(good))
        },
        async printTemplateLabels() {
            this.printShippingLabels.printShippingLabels = orderBy(this.printShippingLabels.printShippingLabels, ['packageIndex', 'goodIndex'], ['asc', 'asc'])

            this.actionLoading = true

            try {
                const promises = []

                if (this.printShippingLabels.printShippingLabels.length > 0) {
                    const regularLabelsPromise = this.$store.dispatch('shipments/shipmentsLabels/printShippingLabel', this.printShippingLabels)
                        .then(response => {
                            openPdfFile(response.data)
                        })

                    promises.push(regularLabelsPromise)
                }

                if (this.selectedLogisticsLabels.length > 0) {
                    const logisticsPayload = {
                        packages: this.selectedLogisticsLabels
                    }
                    const logisticsLabelsPromise = this.$store.dispatch('shipments/shipmentsLabels/printBulkSsccLabels', logisticsPayload)
                        .then(response => {
                            openPdfFile(response.data)
                        })

                    promises.push(logisticsLabelsPromise)
                }

                await Promise.all(promises)

            } catch (error) {
                errorHandler(error)
            } finally {
                this.onClose()
                this.actionLoading = false
            }
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.printShippingLabels.printShippingLabels = []
            }, 500)
        }
    }
}
</script>
